export default __webpack_public_path__ + "arrow_up_right.778c5b27.svg";